export default "__VITE_ASSET__B_3Y9LdP__"